import { render, staticRenderFns } from "./RiskScenario.vue?vue&type=template&id=7147a245&scoped=true&"
import script from "./RiskScenario.vue?vue&type=script&lang=js&"
export * from "./RiskScenario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7147a245",
  null
  
)

export default component.exports